<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" /><pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights"/><list-panel :config="config" :isAutoLoad='1' :rs="rs" @updateIdx="updateIdx" :selIdx="selIdx" />
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin"

export default {
  created: function() {
    this.config.params.xdate1.data=this.fdate.firstOfMonth()
    this.config.params.xdate2.data=this.fdate.lastOfMonth()
    if (this.config.dept){
      this.config.dept.forEach(d=>{
        this.config.params.deptNo.options.push({value:d.deptNo, text: d.deptName})
      })
    }
  },
  data() {
    return {
      config: data
    }
  },
  mixins:[mixin.list]
}
</script>
